import ROOF from "./svg/floor/roof";
import BP1 from "./svg/floor/1";
import BP2 from "./svg/floor/2";
import BP3 from "./svg/floor/3";
import BP4 from "./svg/floor/4";
import BP5 from "./svg/floor/5";

import Siteplan from "./svg/floor/siteplan";
import Comming from "../../../data/LagunaBeachside/sitePlan/svg/coming-soon";

const subType = [
  {
    value: "all",
    title: {
      en: "ALL",
      ru: "Все",
      cn: "全部",
    },
  },
  {
    value: "1-bed",
    title: {
      en: "1 Bedroom",
      ru: "1 Bedroom",
      cn: "1 卧室",
    },
  },
  {
    value: "2-bed",
    title: {
      en: "2 Bedroom",
      ru: "2 Bedroom",
      cn: "2 卧室",
    },
  },
  {
    value: "3-bed",
    title: {
      en: "3 Bedroom",
      ru: "3 Bedroom",
      cn: "3 卧室",
    },
  },
];
const subTabs = [
  {
    value: "all",
    title: {
      en: "All",
      ru: "Все",
      cn: "全部",
    },
    showModal: false,
    img: BP1,
    // img: Siteplan,
  },
  {
    value: "a",
    title: {
      en: "Block 1",
      ru: "Блок 1",
      cn: "1栋",
    },
    showModal: false,
    img: BP1,
  },
  {
    value: "b",
    title: {
      en: "Block 2",
      ru: "Блок 2",
      cn: "2栋",
    },
    showModal: false,
    img: BP1,
  },
  {
    value: "c",
    title: {
      en: "Block 3",
      ru: "Блок 3",
      cn: "3栋",
    },
    showModal: false,
    img: BP1,
  },
  {
    value: "d",
    title: {
      en: "Block 4",
      ru: "Блок 4",
      cn: "4栋",
    },
    showModal: false,
    img: BP1,
    // img: Comming,
  },
];

const type = [
  {
    value: "roof",
    title: {
      en: "roof Floor",
      ru: "roof Floor",
      cn: "roof Floor",
    },
    floorPlan: {
      all: ROOF,
      a: ROOF,
      b: ROOF,
      c: ROOF,
      d: ROOF,
      // d: Comming,
    },
    buttons: subType,
  },
  {
    value: "1st",
    title: {
      en: "1st Floor",
      ru: "1-й этаж",
      cn: "1楼",
    },
    floorPlan: {
      all: BP1,
      a: BP1,
      b: BP1,
      c: BP1,
      d: BP1,
    },
    buttons: subType,
  },
  {
    value: "2nd",
    title: {
      en: "2nd Floor",
      ru: "2-й этаж",
      cn: "2楼",
    },
    floorPlan: {
      all: BP2,
      a: BP2,
      b: BP2,
      c: BP2,
      d: BP2,
    },
    buttons: subType,
  },
  {
    value: "3rd",
    title: {
      en: "3rd Floor",
      ru: "3-й этаж",
      cn: "3楼",
    },
    floorPlan: {
      all: BP3,
      a: BP3,
      b: BP3,
      c: BP3,
      d: BP3,
    },
    buttons: subType,
  },
  {
    value: "4th",
    title: {
      en: "4th Floor",
      ru: "4-й этаж",
      cn: "4楼",
    },
    floorPlan: {
      all: BP4,
      a: BP4,
      b: BP4,
      c: BP4,
      d: BP4,
    },
    buttons: subType,
  },
  {
    value: "5th",
    title: {
      en: "5th Floor",
      ru: "5-й этаж",
      cn: "5楼",
    },
    floorPlan: {
      all: BP5,
      a: BP5,
      b: BP5,
      c: BP5,
      d: BP5,
    },
    buttons: subType,
  },
];
const descriptions = [
  {
    value: "1-bed",
    title: {
      en: "ONE-BEDROOM",
      cn: "1-卧室",
      ru: "1-Спальня",
    },
    des: {
      en:
        "Ideal for the modern lifestyle, the 1-bedroom condominium units at Laguna Beachside start at a spacious 59 sqm. A choice of fit-out options offers the flexibility for owners to customise their own living area.",
      cn:
        "悦海苑的一卧室公寓面积为59平方米起，空间宽敞，是现代生活方式的理想选择。可选的装修方案为业主带来个性定制起居空间的灵活性。",
      ru:
        "Идеально подходят для современного образа жизни, площадь 1 спальных просторных квартир начинается от 59 кв. м.Владельцы могут воспользоваться рядом индивидуальных вариантов обустройства квартиры или выбрать полностью обставленный вариант.",
    },
  },
  {
    value: "2-bed",
    title: {
      en: "TWO-BEDROOM",
      cn: "2-卧室",
      ru: "2-Спальня",
    },
    des: {
      en:
        "The larger 2-bedroom units are designed to enjoy maximum panoramic views from their respective full width lanai.",
      cn: "更大的两卧室公寓可从各自的全宽休闲阳台欣赏到开阔的全景。",
      ru:
        "Планировка квартир с двумя спальнями позволяет максимально наслаждаться панорамнымными видами с их просторных веранд.",
    },
  },
  {
    value: "3-bed",
    title: {
      en: "THREE-BEDROOM",
      cn: "3-卧室",
      ru: "3-Спальня",
    },
    des: {
      en:
        "The 3-bedroom units with the unique semi-outdoor lanai feature provides additional living space, which can be opened up to extend the balcony for relaxed outdoor living, or closed off with an optional glass screen to increase interior floor space",
      cn:
        "三卧室公寓拥有独特的半露天休闲阳台，提供额外的起居空间，并可开放至阳台，尽享休闲户外生活，或选用玻璃封闭以增加室内空间。",
      ru:
        "Варианты с 3 спальнями благодаря уникальной полуоткрытой веранде обеспечивают дополнительное жилое пространство, которое можно оставить открытым для расширения балкона и наслаждаться жизнью на свежем воздухе, или же остеклить для увеличения площади внутреннего пространства.",
    },
  },
];

export default {
  // maps,
  type,
  subTabs,
  descriptions,
};



// WEBPACK FOOTER //
// ./src/data/LagunaBeachside/sitePlan/index.js